// extracted by mini-css-extract-plugin
module.exports = {"root":"_3nmm7","edit-menu":"_1bDHu","editMenu":"_1bDHu","pinned-icon":"_3gbxH","pinnedIcon":"_3gbxH","draft":"_18mtg"};